import { createFileRoute, useParams } from "@tanstack/react-router"
import { checkPermissions } from "@/utils/checkPermissions"
import { useClassroomSuspenseQuery } from "@/api/queries/classrooms/useClassroomSuspenseQuery"
import { scheduleQueryKeys } from "toptaal-shared"
import { getClassroomsSchedule } from "@/api/services/locations"
import { CalendarWithModal } from "@/components/modals/calendar/CalendarWithModal"

export const Route = createFileRoute(
  "/beheer/locaties/$locationId/classrooms/$classroom",
)({
  component: LocationOverview,
  beforeLoad: () => checkPermissions("read", "locations"),
})

function LocationOverview() {
  const { locationId, classroom } = useParams({
    from: "/beheer/locaties/$locationId/classrooms/$classroom",
  })

  const {
    data: { classrooms },
  } = useClassroomSuspenseQuery({
    locationId: Number(locationId),
  })

  const activeClassroom = classrooms.find(
    (c) => c.id === Number(classroom) || c.number === classroom,
  )

  return (
    <section className="flex-1 min-w-0 flex flex-col gap-4 overflow-hidden h-full">
      {activeClassroom && (
        <CalendarWithModal
          id={activeClassroom.id}
          getQueryKey={scheduleQueryKeys.classroom}
          queryFn={({ id: classroomId, startDate, endDate }) =>
            getClassroomsSchedule({ classroomId, startDate, endDate })
          }
        />
      )}

      {!activeClassroom && (
        <div className="flex items-center justify-center h-full">
          <p className="text-gray-500">
            Selecteer een lokaal om de planning te bekijken
          </p>
        </div>
      )}
    </section>
  )
}
